import { render, staticRenderFns } from "./banner-location-select.vue?vue&type=template&id=355c8a62"
import script from "./banner-location-select.vue?vue&type=script&lang=js"
export * from "./banner-location-select.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports